module.exports = __webpack_public_path__ + "static/media/preloader.781e2e79.gif";


//////////////////
// WEBPACK FOOTER
// ./src/theme/assets/preloader.gif
// module id = 742
// module chunks = 0